import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { VideoJsPlayer } from 'video.js';
import {  ButtonIcon, NextActionBarBtn, Timer } from '../styles';
import { timeToSeconds } from '../../../utils';
import { IconClose, IconNextEpisode } from '../../../icons';
import { Flex } from '../../../styles';
import { __t } from '../../../i18n';
import UsePlayerProps from '../../../Store/usePlayerProps';

const NextEpisodeButton = ({
  player,
}: {
  player: VideoJsPlayer;
}) => {
  const contentConfigs = UsePlayerProps((state) => state.playerState.contentConfigs);
  const setPlayerGlobalState = UsePlayerProps((state) => state.setPlayerState);
  const counterTime = contentConfigs?.next_episode?.auto_switch_time || 11;
  const [cancelled, setCancelled] = useState(false);
  const [showNext, setShowNext] = useState<boolean>(false);
  const [counter, setCounter] = useState<number>(counterTime);
  const router = useRouter();
  const nextEpisodeId = contentConfigs?.next_episode?.id;

  const handleNextEpisode = () => {
    if (nextEpisodeId) {
      router.replace(`/play/${nextEpisodeId}/p`).then(() => {
        setPlayerGlobalState({
          contentConfigs: null,
          contentData: null,
          sources: null,
          vttData: null,
          captionState: {
            prevCaptionIndex: -1,
            selectedCaptionLang: {
              lang: 'off',
              label: 'خاموش',
            },
          },
          showingNextEpisode: true,
        });
      });
    }
  };

  const endTitration = contentConfigs && contentConfigs?.titrations?.find((item) => item.video_file_titrations_type === 'end');
  useEffect(() => {
    if (cancelled) return;

    const handleTimeUpdate = () => {
      const currentTime = player.currentTime();
      const duration = player.duration();
      if (endTitration) {
        if (timeToSeconds(endTitration.start_time) <= currentTime) {
          setShowNext(true);
        } else {
          setShowNext(false);
          setCounter(counterTime);
        }
      } else if (duration - currentTime <= counterTime) {
        setShowNext(true);
      } else {
        setShowNext(false);
        setCounter(counterTime);
      }
    };

    player.on('timeupdate', handleTimeUpdate);
    return () => {
      player.off('timeupdate', handleTimeUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const triggerTimer = useRef<any>();
  const contDownTimer = useRef<any>();

  useEffect(() => {
    if (showNext) {
      triggerTimer.current = setTimeout(() => {
        handleNextEpisode();
      }, counterTime * 1000);
    }
    if (showNext && counter > 0) {
      contDownTimer.current = setInterval(() => {
        setCounter((counter) => counter - 1);
      }, 1000);
    }
    if (cancelled) {
      clearTimeout(triggerTimer.current);
      clearInterval(contDownTimer.current);
    }

    return () => {
      clearTimeout(triggerTimer.current);
      clearInterval(contDownTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancelled, showNext]);

  if (cancelled || !showNext) return null;

  return (
    <>
      <NextActionBarBtn onClick={handleNextEpisode}>
        <Flex justify="center" align="center">
          <Timer>
            ({counter})
          </Timer>
          {__t('player.play_next_episode')}
          <IconNextEpisode />
        </Flex>
      </NextActionBarBtn>
      <ButtonIcon onClick={() => setCancelled(true)}>
        <IconClose />
      </ButtonIcon>
    </>
  );
};

export default NextEpisodeButton;
